import { Routes } from '@angular/router';
import { StepIds } from '../models/property-step/property-step-model';
import { ResidentialForRentPropertyDescriptionComponent } from '../pages/category-page-overrides/residential-for-rent/property-description-page.component';
import { ResidentialForRentPropertyInformationComponent } from '../pages/category-page-overrides/residential-for-rent/property-information-page.component';
import { PropertyPhotosPageComponent } from '../pages/property-default-pages/property-photos-page/property-photos-page.component';
import { PropertyPromotePageComponent } from '../pages/property-default-pages/property-promote-page/property-promote-page.component';
import { PropertySummaryPageComponent } from '../pages/property-default-pages/property-summary-page/property-summary-page.component';

export const residentialForRentRoutes: Routes = [
    {
        path: StepIds.propertyInformation,
        component: ResidentialForRentPropertyInformationComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyInformation
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/residential-for-rent/property-information-page.module'
            ).then((mod) => mod.ResidentialForRentPropertyInformationPageModule)
    },
    {
        path: StepIds.propertyDescription,
        component: ResidentialForRentPropertyDescriptionComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyDescription
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/residential-for-rent/property-description-page.module'
            ).then((mod) => mod.ResidentialForRentPropertyDescriptionPageModule)
    },
    {
        path: StepIds.propertyPhotos,
        component: PropertyPhotosPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPhotos
            }
        }
    },
    {
        path: StepIds.propertyPromote,
        component: PropertyPromotePageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPromote
            }
        }
    },
    {
        path: StepIds.propertySummary,
        component: PropertySummaryPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertySummary
            }
        },
        loadChildren: () =>
            import(
                '../pages/property-default-pages/property-summary-page/property-summary-page.module'
            ).then((mod) => mod.PropertySummaryPageModule)
    },
    {
        path: '',
        redirectTo: StepIds.propertyInformation,
        pathMatch: 'full'
    }
];
